import React from 'react';
import { FiEdit } from 'react-icons/fi';
import TableColumnTitle from '../../../../../../components/_table/TableColumnTitle';
import { setDateFormat } from '../../../../../../lib/moment';
import SwitchForm from '../../../../../../components/form/SwitchForm';
import { openNewWindow, reDirectPage, setDash, setDetailPageUrl } from '../../../../../../lib/common';
import { SUB_PAGE_MANAGEMENT_URL_PATH } from '../../../../../../constants/service/common/urlConstants';
import Button from '../../../../../../components/Button';
import Anchor from '../../../../../../components/link/Anchor';

/**
 *  서브 페이지 컬림
 */
export const columns = (data) => {
  const { updateSubPageStatus, deleteSubPage } = data;

  return [
    {
      title: <TableColumnTitle title={'수정'} />,
      dataIndex: 'edit',
      render: (value, record) => (
        <FiEdit onClick={() => reDirectPage({ path: setDetailPageUrl(SUB_PAGE_MANAGEMENT_URL_PATH, record.id) })} />
      ),
    },
    {
      title: <TableColumnTitle title={'활성화'} />,
      dataIndex: 'status',
      render: (value, record, index) => (
        <SwitchForm
          checked={!!value}
          onChange={(value) =>
            updateSubPageStatus({
              linkedHomeTab: record.linkedHomeTab,
              linkedHomeMenu: record.linkedHomeMenu,
              subPageId: record.id,
              status: value,
              index,
            })
          }
        />
      ),
    },
    {
      title: <TableColumnTitle title={'서브 페이지 ID'} />,
      dataIndex: 'id',
      render: (value) => (
        <Anchor
          color="primary"
          isUnderLine
          text={value}
          onClick={() => openNewWindow(setDetailPageUrl(SUB_PAGE_MANAGEMENT_URL_PATH, value))}
        />
      ),
    },
    {
      title: <TableColumnTitle title={'페이지 제목'} />,
      dataIndex: 'title',
      render: (value) => setDash(value),
    },
    {
      title: <TableColumnTitle title={'메모'} />,
      dataIndex: 'memo',
      ellipsis: true,
      render: (value) => setDash(value),
    },
    {
      title: <TableColumnTitle title={'링크된 메뉴'} />,
      dataIndex: 'linkedHomeMenu',
      render: (value) => setDash(value),
    },
    {
      title: <TableColumnTitle title={'링크된 홈탭'} />,
      dataIndex: 'linkedHomeTab',
      render: (value) => setDash(value),
    },
    {
      title: <TableColumnTitle title={'생성일'} />,
      dataIndex: 'createDate',
      render: (value) => setDateFormat(value),
    },
    {
      title: <TableColumnTitle title={'삭제하기'} />,
      dataIndex: 'delete',
      render: (value, record) =>
        record.linkedHomeMenu || record.linkedHomeTab ? (
          '삭제 불가능'
        ) : (
          <Button
            isRadius
            color="red"
            text="삭제"
            onClick={() =>
              deleteSubPage({
                subPageId: record.id,
              })
            }
          />
        ),
    },
  ];
};
